import { render, staticRenderFns } from "./ItirazinIptaliAlacakKalemiList.vue?vue&type=template&id=60f90ebc"
import script from "./ItirazinIptaliAlacakKalemiList.vue?vue&type=script&lang=ts"
export * from "./ItirazinIptaliAlacakKalemiList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports